import React,{useState, useEffect} from 'react';
import { Navbar, Nav, Container} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFeather, faCircleNotch, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Commentary from './commentary';
import Note from './note';
import FlipCard from './flipcard';
import Deck from './deck';
import { getByTitle } from '@testing-library/react';
import { isMobile, isTablet, isIOS } from 'react-device-detect';
import { useLanguage } from '../i18n/LanguageContext';

function Single(props) {
  const { t } = useLanguage();

  //generate a new random card on start
  var key;
  if (props.card){
    key = props.card.card;
  }
  else{
    key = getKey();
  }

  const [shuffle, setShuffle] = useState(false);
  const [currentCard, setCard] = useState(key);
  const [currentTitle, setTitle] = useState("");
  const [show, setShow] = useState(false);
  const [showSaved, setShowSaved] = useState(props.card != null);
  const [saved, setSaved] = useState(props.card);
  const [showNote, setShowNote] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);
 
  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  const rotation = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  useEffect(() => {
    
    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
    
  },[]);

  function handleClick(flipped){
    
    if (flipped){
      //Click on card, show commentary
      handleShow();
    }
    else{
      setShowSaved(true);
    }
  }

  function getKey(){
    var key;
    for (var i=0; i<7; i++){
      key = (Math.floor(Math.random() * 108) + 1).toString();
    }
    
    return key;
  }

  function handleSelect(action){
    if (action == "new"){
      var key = getKey();
      
      setCard(key);
      setSaved(null);
      setTimeout(function(){
        setShuffle(true);
      },500)
     
      setShowSaved(false);
    }
    else if(action == "save"){
      //save card to storage with date
      setShowNote(true);
    }
    else if(action == "back"){
      props.onBackSelected();
    }
  }
  
  function handleNoteClose(saved, card){
    setShowNote(false);
    if (saved){
      setSaved(card);
    }
  }
  
  function handleTitle(title){
    if (currentTitle != title){
      setTitle(title);
    }
  }

  var justify = "justify-content-center";
  if (saved != null){
    justify = "justify-content-start";
  }

  function getTitle(){
    if(saved){
      return saved.title
    }
    else{
      return currentTitle;
    }
  }
  
  function getCard(){

    var cardWidth = 'min(calc(70vw),350px)';
    var cardHeight = 'min(calc(70vw * 1.3),calc(350px * 1.3))';

    if (shuffle){
      setTimeout(function(){
        setShuffle(false);
      },1500)
      
      return (
        <Deck height={cardHeight} width={cardWidth}/>
      //<ShuffleCard key={0} height={'calc(100vh - 260px - env(safe-area-inset-top) - env(safe-area-inset-bottom))'} width={'calc((100vh - 260px - env(safe-area-inset-top) - env(safe-area-inset-bottom))*0.7)'}></ShuffleCard>
      )
    }
    else{

      return (
      <FlipCard onClick={handleClick} card={currentCard} flipped={props.card != null} height={cardHeight} width={cardWidth}></FlipCard>
    );
    }
  }

  function getScrollHeight(){
    var scrollHeight = "'auto'";
    if (height < 500){
      scrollHeight = "calc(" + height.toString() + "px + 200px - env(safe-area-inset-top) - env(safe-area-inset-bottom))";
    }
    return scrollHeight;
  }

  var saveNote = t('common.saveNotes');
  if (saved){
    saveNote = t('common.notes');
  }

  var time = "";
  if (props.card){
    time = props.card.time;
  }
  
  return (
    <div id="container">
     <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{width: "100%", paddingBottom:0, paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
        <Nav fill style={{width: "100%"}} className={justify} onSelect={handleSelect}>
          <Nav.Link eventKey="back" hidden={props.card == null} style={{textAlign: "left", marginLeft:"10px"}}><span aria-hidden="true" class="carousel-control-prev-icon" style={{verticalAlign:'middle'}}/></Nav.Link>
          <Nav.Link eventKey="new" hidden={props.card != null}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faCircleNotch}  size='1x'  /> {t('common.shuffle')} </span></Nav.Link>
          <Nav.Link eventKey="back" hidden={props.card == null}><span style={{verticalAlign:'middle'}}>{time}</span></Nav.Link>
          <Nav.Link eventKey="save" hidden={!showSaved}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faFeather}  size='1x' /> {saveNote} </span></Nav.Link>
        </Nav>
      </Navbar>
  
      <div style={{paddingTop:'0px',paddingBottom:'85px', position:'absolute', top:0, left:0,transform:'translate(max(calc(50vw - 70vw / 2),calc(50vw - 350px /2)), calc(env(safe-area-inset-top) + ' + height * 0.2 + 'px))', 
      height:getScrollHeight()}}>
        {getCard()}
      </div>
    
      <Commentary card={currentCard} show={show} placement="bottom" name="bottom" onHide={handleClose} onLoad={handleTitle}></Commentary>
      <Note className="saveCardDialog" card={currentCard} title={getTitle()} saved={saved} type="card" show={showNote} onHide={handleNoteClose}></Note>
    </div>
  )
};

export default Single;